<nz-space class="mobile-report-control">
  <app-purchaser-select [showAddNewButton]="false" [(ngModel)]="from" class="report-control"
    (ngModelChange)="fromChange.emit($event)" valueField="code" [activeOnly]="false">
  </app-purchaser-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-purchaser-select [showAddNewButton]="false" [(ngModel)]="to" class="report-control"
    (ngModelChange)="toChange.emit($event)" valueField="code" [activeOnly]="false"></app-purchaser-select>
</nz-space>